import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { CompletedPopupComponent } from 'src/app/core/components/completed-popup/completed-popup.component';
import { UserService } from 'src/app/services/user.service';
import { IChangePassForm } from 'src/app/shared/model/form.model';

@Component({
  selector: 'app-admin-change-password',
  templateUrl: './admin-change-password.component.html',
  styleUrls: ['./admin-change-password.component.scss'],
})
export class AdminChangePasswordComponent {
  changeForm!: FormGroup;
  errMsg = '';
  isLoading = false;

  constructor(
    private fb: FormBuilder,
    private userService: UserService,
    public matDialog: MatDialog
  ) {}

  ngOnInit(): void {
    this.initForm();
  }
  initForm() {
    this.changeForm = this.fb.group({
      oldPassword: [null, Validators.required],
      newPassword: [null, Validators.required],
      cNewPassword: [null, Validators.required],
    });
  }

  onOpenCompleted() {
    const dialogRef = this.matDialog.open(CompletedPopupComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '300ms',
      width: '600px',
      data: { location: window.location.pathname },
      disableClose: true,
    });
  }

  formSummary(): IChangePassForm {
    const changeData = {
      oldPassword: this.changeForm.value.oldPassword,
      password: this.changeForm.value.newPassword,
    };

    return changeData;
  }

  onSubmit() {
    this.errMsg = '';

    if (this.changeForm.invalid) {
      this.changeForm.markAllAsTouched();
    } else if (
      this.changeForm.controls['newPassword']?.value !==
      this.changeForm.controls['cNewPassword']?.value
    ) {
      alert(
        'Passwords do not match. Please re-enter your password to confirm.'
      );
    } else {
      this.isLoading = true;
      const changeData = this.formSummary();
      this.userService.changePassword(changeData).subscribe({
        next: (data) => {
          console.log(data);
          this.isLoading = false;
        },
        error: (err) => {
          this.errMsg = err.statusMessage;
          this.isLoading = false;
        },
        complete: () => {
          this.isLoading = false;
          this.onOpenCompleted();
        },
      });
    }
  }
}
